module.exports = __webpack_public_path__ + "img/8.0b9c5bac.png";